export default {
  /** 实时库存列表 */
  REAL_TIME_STOCK: '/component/logisticsReport/listReport',
  /** 物流库存明细列表 */
  LOGISTICS_STOCK: '/component/logisticsReport/listDetailReport',
  /** 物流库存明细列表 */
  REAL_TIME_EXPORT: '/component/logisticsReport/exportReport',
  /** 导出物流库存明细表 */
  LOGISTICS_EXPORT: '/component/logisticsReport/exportDetailReport',
};
